import { Component, OnInit,Input } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { project_status_key_class } from "../../../../core/helpers/pm-helper";

@Component({
	selector: 'app-pm-dashboard-table',
	templateUrl: './pm-dashboard-table.component.html',
	styleUrls: ['./pm-dashboard-table.component.scss']
})

export class PmDashboardTableComponent implements OnInit {
	public scrollConfig: PerfectScrollbarConfigInterface = {};
	@Input() projects;
	@Input() loginUser;
	@Input() userLists;
	@Input() apiUrl;
	projectstatusKeyClass = project_status_key_class;

	constructor() { }

	ngOnInit() {}

}
